import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { HttpUtilsService, LayoutUtilsService } from '../_base/crud';
import { Store } from '@ngrx/store';
import { AppState } from '../reducers';
import { FilteredViewService } from './filtered-view.service';
import { CreateFilteredViewDialogComponent } from '../../views/pages/filtered-view/create-filtered-view-dialog/create-filtered-view-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from '../auth';
import { ContextualHistoryService } from '../../views/partials/content/general/contextual-history/services/contextual-history.service';
import { take } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GlobalSettingsService {
  private filteredView: any;
  private filteredViewOb = new BehaviorSubject(false);
  private filteredId: any;
  hideFilteredViewInDashboard: string;
  private loadTaskList = new BehaviorSubject<boolean>(false);
  $loadTaskList = this.loadTaskList.asObservable();
  private loadLinkList = new BehaviorSubject<boolean>(false);
  $loadLinkList = this.loadLinkList.asObservable();

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
    private filteredViewService: FilteredViewService,
    private layoutUtilsService: LayoutUtilsService,
    private router: Router,
    public dialog: MatDialog,
    private contextualHistoryService: ContextualHistoryService,
    private authService: AuthService,
  ) {
    const filteredView = localStorage.getItem('filteredView');
    const filteredViewObject = localStorage.getItem('filteredViewObject');
    const relatedFilteredView = localStorage.getItem('relatedFilteredView');
    const filteredViewId = localStorage.getItem('filteredViewId');
    const trackerToken = localStorage.getItem('trackerToken');
    const selectedFilterOptions = localStorage.getItem('selectedFilterOptions');

    this.hideFilteredViewInDashboard = filteredView;
    localStorage.removeItem('filteredView');
    localStorage.removeItem('filteredViewObject');
    localStorage.removeItem('relatedFilteredView');
    localStorage.removeItem('filteredViewId');
    localStorage.removeItem('selectedFilterOptions');
    if (filteredView && filteredViewId && trackerToken) {
      const userSub = this.authService.getUser().subscribe((user) => {
        if (!user) {
          return;
        }
        setTimeout(() => {
          const _title = 'Note';
          const _description =
            'There is an opened filtered session for you. do you want to continue using focused view?';
          const _waitDesciption = 'Wait please ..';

          const dialogRef = this.layoutUtilsService.confirmAction(
            _title,
            _description,
            _waitDesciption,
          );
          dialogRef.afterClosed().subscribe((res) => {
            if (userSub && userSub.unsubscribe) {
              userSub.unsubscribe();
            }
            this.setFilteredView(true);
            this.filteredViewOb.next(true);
            this.filteredViewService.setFilteredObject(JSON.parse(filteredViewObject));
            this.filteredViewService.setAllRelatedFilter(JSON.parse(selectedFilterOptions));
            this.filteredViewService.setRelatedFilter(JSON.parse(relatedFilteredView));
            this.filteredViewService.setFilteredViewId(filteredViewId);
            this.filteredViewService.setTrackerToken(trackerToken);
            if (!res) {
              // todo add request to close the session
              this.dialog.open(CreateFilteredViewDialogComponent, {
                width: '800px',
                data: {
                  sessionOpened: this.isFilteredView(),
                  preventCancel: true,
                },
                disableClose: true,
              });
              return;
            }

            this.setFilteredView(true);
            this.filteredViewService.setFilteredObject(JSON.parse(filteredViewObject));
            this.filteredViewService.setRelatedFilter(JSON.parse(relatedFilteredView));
            this.router.navigate(['/filtered-view']);

            const filteredViewObj = JSON.parse(filteredViewObject);

            this.filteredViewService
              .getAllPatients(
                filteredViewObj.selectedFilter.map((idObj) => idObj.filter_id),
                filteredViewObj.filterType,
              )
              .pipe(take(1))
              .subscribe((patients) =>
                this.contextualHistoryService.setFieldsData(
                  '/filtered-view/dashboard',
                  filteredViewObj.contact.id,
                  patients?.data?.map((patient) => patient.id),
                ),
              );
          });
        }, 3000);
      });
    }

    const sub = this.route.queryParams.pipe().subscribe((params) => {
      this.filteredView = this.filteredView || params.filteredView;
      if (params.filteredView) {
        this.filteredId = params.filteredId;
        sub.unsubscribe();
      }
    });

    window.addEventListener('beforeunload', () => {
      if (this.isFilteredView()) this.saveFilteredViewState();
    });
  }

  loadTasks() {
    this.loadTaskList.next(true);
  }
  loadLinks() {
    this.loadLinkList.next(true);
  }

  isFilteredView() {
    return this.filteredView;
  }

  isFilteredViewOb() {
    return this.filteredViewOb.asObservable();
  }

  getFilteredViewValue() {
    return this.filteredId;
  }

  getFilteredViewName() {
    return 'contact';
  }

  setFilteredView(val: boolean) {
    this.filteredView = val;
    this.filteredViewOb.next(this.filteredView);
  }

  saveFilteredViewState() {
    localStorage.setItem('filteredView', JSON.stringify(this.isFilteredView()));
    localStorage.setItem(
      'selectedFilterOptions',
      JSON.stringify(this.filteredViewService.getAllRelatedFilter()),
    );
    localStorage.setItem(
      'filteredViewObject',
      JSON.stringify(this.filteredViewService.getFilteredObject()),
    );
    localStorage.setItem(
      'relatedFilteredView',
      JSON.stringify(this.filteredViewService.getRelatedFilter()),
    );
    localStorage.setItem('filteredViewId', String(this.filteredViewService.getFilteredViewId()));
    localStorage.setItem('trackerToken', String(this.filteredViewService.getTrackerToken()));
  }

  getTrackerTokenName() {
    return 'trackerToken';
  }

  getTrackerTokenValue() {
    return this.filteredViewService.getTrackerToken();
  }

  getPlusCode(term) {
    const encodedParam = encodeURIComponent(term);
    const url = `https://plus.codes/api?key=${environment.API_KEY}&address=${encodedParam}&language=en`;
    return this.http.get<any>(url);
  }
}
